const ParseListToFormattedString = (listOfStrings) => {
	/*
        This function converts a list of strings to
        one string separeted by commas or 'and' for
        the last element and ends with a period.

        i.e. ['Moo', 'Cow', 'Quack'] becomes 'Moo, Cow and Quack'
    */

	const list = listOfStrings;
	const numElements = list.length;

	// if there are no elements in the list, return an empty string.
	if (numElements === 0) {
		return "";
	}
	// if there is only one element in the list,
	// add a period and return as string i.e ['Moo'] will return 'Moo.'
	else if (numElements === 1) {
		return `${list.join()}.`;
	}

	// get the last and second to last elements to compare with.
	const lastElement = list[numElements - 1].trim();
	const secondToLastElement = list[numElements - 2].trim();

	const parsed = list
		.map((element) => {
			const trimmed = element.trim();
			if (trimmed === lastElement) {
				return `${trimmed}.`;
			} else if (trimmed === secondToLastElement) {
				return `${trimmed} and `;
			}

			return `${trimmed}, `;
		})
		.join("");
	return parsed;
};

export default ParseListToFormattedString;
